/**
 * Samtycke särskilda kategorier — the standalone, signed sibling of the
 * samtycke-bilaga. §§ 2–8 are the bilaga's own blocks; the avtalsref line,
 * § 1 Parter (autofilled from the parties) and the closing § 9 (consent +
 * Underskrifter) are specific to this document.
 */
import { p, section } from '@hyranai/regta-document-ir';
import { signingNodes } from '../common/index.js';
import { legalBase } from '../personuppgiftsbilaga/text.js';
import { SAMTYCKE_TEXT, SOURCE, avtalsrefBlock, parterBlock } from '../samtycke_sarskilda_bilaga/blocks.js';
export const avtalsref = avtalsrefBlock('samtycke_sarskilda_avtal.avtalsref', 'standalone');
export const parter = parterBlock('samtycke_sarskilda_avtal.parter', 'standalone');
/** The legacy SigningBlock here carries no execution statement (no `statement` input). */
export const samtycke = {
    ...legalBase(SOURCE),
    blockKey: 'samtycke_sarskilda_avtal.samtycke',
    version: 'v1',
    title: 'Samtycke',
    summary: 'The tenant’s explicit consent followed by the signature panels of tenant and landlord.',
    slots: [],
    compile: (input, ctx) => [
        section('samtycke', 'Samtycke', [p(SAMTYCKE_TEXT), ...signingNodes(input, ctx)], { keepTogether: true }),
    ],
};
export const SAMTYCKE_SARSKILDA_AVTAL_BLOCKS = [avtalsref, parter, samtycke];
//# sourceMappingURL=blocks.js.map